import { cn } from '@/lib/utils'

const CULTURE_LABEL: Record<string, string> = {
  'fr-BE': 'FR',
  'nl-BE': 'NL',
  'en-GB': 'EN',
}

interface CultureBadgeProps {
  culture: string
  className?: string
}

/**
 * Compact two-letter culture pill — used by table headers and missing-culture
 * indicators across the admin translations page.
 */
export function CultureBadge({ culture, className }: CultureBadgeProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center justify-center rounded px-1.5 py-0.5 text-[10px] font-semibold uppercase tracking-wide',
        'bg-muted text-muted-foreground',
        className
      )}
    >
      {CULTURE_LABEL[culture] ?? culture}
    </span>
  )
}
